module.exports = __webpack_public_path__ + "img/MT-SZP_PH2_5853_960x355.715648b2.jpg";